import React from 'react';
import tabStyles from 'assets/css/Tab.module.css';
import eventStyles from 'assets/css/Event.module.css';
import AceAnswersRegisteredEvent from 'Components/Card/Components/AceAnswersRegisteredEvent';
import EventPartials from 'Components/Card/Partials/Partials.Event';
import { getUTCDateFromServerDate } from 'utils/dateUtils';

const AceAnswersEventPartials = {
    EventSelector: (props) => (
        <div className={`${tabStyles.tab} ${props.isActive ? tabStyles.tabActive : ""}`} onClick={() => props.setPanel(props.displayName)}>
            {props.displayName}
        </div>
    ),
    EventMap: (props) => {
        const {
            eligible,
            events,
            eventType: EventType
        } = props;
        if (EventType === AceAnswersRegisteredEvent && eligible && !events.length) {
            return (
                <>
                    <h4 className={eventStyles.title}>Nothing scheduled.</h4>
                    <p style={{fontFamily: "Muli", fontSize: "0.875rem", fontWeight: "400", marginTop: ".5rem", marginBottom: ".5rem", lineHeight: "1.75"}}>Select the "Register" tab above to browse and register for upcoming {props.cardTitle}.</p>
                </>
            )
        }
        if (!events.length) {
            return false;
        }
        return (
            events.map(event => (<EventType event={event} eligible={eligible} />))
        );
    },
    EventDisplay: (props) => {
        //local var(s)
        const { event, children } = props; //, menu, btn } = props;
        const displayProps = { 
            startDate: getUTCDateFromServerDate(event.EventDateTime), 
            endDate: getUTCDateFromServerDate(event.EventEnd), 
            eventTitle: event.EventDisplayTitle 
        };

        //render
        return (
            <EventPartials.EventDisplay {...displayProps} >
                <EventPartials.EventOrganizer eventOrganizerDisplay={event.EventOrganizerDisplay} />
                {children}
            </EventPartials.EventDisplay>
        )
    }
};

export default AceAnswersEventPartials;

export const ACE_ANSWERS_EVENT_CONSTANTS = {
    EVENT_TYPES: {
        AVAILABLE: "Register",
        REGISTERED: "Scheduled"
    }
};

export const aceAnswersEventHelpers = {
    isPanelDisplayRegistered: (panel) => (panel === ACE_ANSWERS_EVENT_CONSTANTS.EVENT_TYPES.REGISTERED),
    isPanelDisplayAvailable: (panel) => (panel === ACE_ANSWERS_EVENT_CONSTANTS.EVENT_TYPES.AVAILABLE)
};

